module.exports = __webpack_public_path__ + "static/media/add.cbb9f308.png";